import {
  GOLD_REPORT_ALL,
  GOLD_REPORT_GET,
  GOLD_REPORT_DEL,
  GOLD_REPORT_PUT,
  GOLD_REPORT_POST,
  GOLD_REPORT_LOADING,
  GOLD_REPORT_ERROR,
} from '../../actions/types';

const initialState = {
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case GOLD_REPORT_LOADING:
      return { isLoading: true, isCompleted: true };
    case GOLD_REPORT_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case GOLD_REPORT_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case GOLD_REPORT_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case GOLD_REPORT_POST:
      return { isLoading: false, isCompleted: true };
    case GOLD_REPORT_PUT:
      return { isLoading: false, isCompleted: true };
    case GOLD_REPORT_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
